import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'decodeUriSpaces',
    standalone: false
})
export class DecodeUriSpacesPipe implements PipeTransform {
  transform(value: string | undefined | null): string {
    return value ? value.replace(/%20/g, ' ') : '';
  }
}